module.exports = __webpack_public_path__ + "static/media/truck-green.49c9cf5a.svg";